import { ca } from '@cian/analytics';
import { IApplicationContext } from '../../common/types/applicationContext';

export function clickSellerSendForm(context: IApplicationContext['custom']) {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    action: 'сlick',
    category: 'DemandCpd',
    label: 'send',
    page: {
      pageType: 'DemandCpdLandingPage',
      extra: {
        source,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
      },
    },
    user: {
      userId: cianUserId,
    },
  });
}

export function clickSellerOpenModal(label: string, context: IApplicationContext['custom']) {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    action: 'сlick',
    category: 'DemandCpd',
    label,
    page: {
      pageType: 'DemandCpdLandingPage',
      extra: {
        source,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
      },
    },
    user: {
      userId: cianUserId,
    },
  });
}

export function successSellerSendForm(draftId: number, context: IApplicationContext['custom']) {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    action: 'Send',
    category: 'DemandCpd',
    label: 'Success',
    page: {
      pageType: 'DemandCpdLandingPage',
      extra: {
        source,
        draft_id: draftId,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
      },
    },
    user: {
      userId: cianUserId,
    },
  });
}

export function clickSellerConsultation(
  context: IApplicationContext['custom'],
  type: 'consultation' | 'consultation_jivo',
) {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'DemandCpd',
    label: type,
    page: {
      pageType: 'DemandCpdLandingPage',
      extra: {
        source,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
      },
    },
    user: {
      userId: cianUserId,
    },
  });
}

export function showAgentCommissionBlock(context: IApplicationContext['custom']) {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    action: 'Show_sopr',
    category: 'DemandCpd',
    label: 'agent_commission',
    page: {
      pageType: 'DemandCpdLandingPage',
      extra: {
        source,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
      },
    },
    user: {
      userId: cianUserId,
    },
  });
}

export const showSellerHowItWork = (context: IApplicationContext['custom']) => {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'Show_sopr',
    label: 'SafeDeal',
    page: {
      pageType: 'DemandCpdLandingPage',
      extra: {
        source,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
        cpdDealType: 'buy',
      },
    },
    user: {
      userId: cianUserId,
    },
  });
};

export const clickSellerGarantLink = (
  context: IApplicationContext['custom'],
  label: 'SafeDealCertificateExample' | 'SafeDealCertificateExample2' | 'SafeDealReportExample',
) => {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'click',
    label,
    page: {
      pageType: 'DemandCpdLandingPage',
      extra: {
        source,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
        cpdDealType: 'buy',
      },
    },
    user: {
      userId: cianUserId,
    },
  });
};

export function clickFaqAgentCommission(context: IApplicationContext['custom']) {
  const { cianUserId, source, utm_source, utm_campaign, utm_medium, cpdOfferType } = context;

  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'DemandCpd',
    label: 'FaqSafeDeal',
    page: {
      pageType: 'DemandCpdLandingPage',
      extra: {
        source,
        utm_source,
        utm_campaign,
        utm_medium,
        cpdOfferType,
      },
    },
    user: {
      userId: cianUserId,
    },
  });
}
